import { SxProps } from '@mui/material';
import { black1, grey9 } from 'app/components/ThemeProvider/colors';

export const card: SxProps = {
  display: 'flex',
  gap: '20px',
  flexDirection: 'column',
  backgroundColor: 'white',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  padding: '24px',
  width: 'calc((100% / 2) - 8px)',
  borderRadius: '8px',

  '&:hover': {
    cursor: 'pointer',
  },

  '@media screen and (max-width: 768px)': {
    width: '100%',
  },
};
export const title: SxProps = {
  fontSize: '20px',
  fontWeight: 600,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: '50%',
};

export const typeText: SxProps = {
  fontSize: '13px',
  fontWeight: 400,
  color: 'rgba(20, 25, 31, 0.4)',
};

export const infoText: SxProps = {
  fontSize: '17px',
  fontWeight: '500',
};

export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};
